import e from "../../utils/classNames.js";
import { useEffect as t, useRef as n, useState as r } from "react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/components/formLabel/FormLabel.tsx
var o = (o) => {
	let { className: s = "", children: c, supportingText: l, ...u } = o, d = n(null), [f, p] = r(null), m = "htmlFor" in u;
	t(() => {
		if (!d.current) return;
		let e = d.current.parentElement;
		e && (e.classList.contains("form-group-lg") ? p("lg") : e.classList.contains("form-group-sm") && p("sm"));
	}, []);
	let h = e("text-color-gray", typeof l == "string" && "text-italic", f === "sm" && "text-size-10", f === "lg" && "text-size-14", !f && "text-size-12");
	if (m && u.htmlFor) {
		let t = e(!l && "display-inline-block", l && "display-inline-flex flex-wrap justify-content-between width-100pct", s);
		return /* @__PURE__ */ a("label", {
			ref: d,
			...u,
			className: t,
			children: [/* @__PURE__ */ i("span", { children: c }), l && /* @__PURE__ */ i("span", {
				className: h,
				children: l
			})]
		});
	}
	let g = e("text-color-dark", "max-width-100pct", f === "sm" && "text-size-10", f === "lg" && "text-size-14", !f && "text-size-12", !l && "display-inline-block", l && "display-inline-flex flex-wrap justify-content-between width-100pct", !s.includes("margin-bottom") && "margin-bottom-5", s);
	return /* @__PURE__ */ a("div", {
		ref: d,
		...u,
		className: g,
		children: [c, l && /* @__PURE__ */ i("span", {
			className: h,
			children: l
		})]
	});
};
//#endregion
export { o as default };

//# sourceMappingURL=FormLabel.js.map